import Api, { ImgAPI } from "../../apiclient/api";

//handing authorization part
const handleAuth = async (data, customer, setCustomer, rf, navigate) => {
    //if token expired then logout

    if (data?.status === "Expire") {
        setCustomer?.({});
        // await UpdateRF(rf);
        navigate("/login");
        return null;
    }else{
        if(data?.authorization){
            setCustomer((prev) => ({
                ...prev,
                token: {
                ...prev?.token,
                authorization: data?.authorization,
                },
            }));
        }
        
    }

    //if there is customer and auth so set authorization
    if (data?.authorization && customer) {
        setCustomer(prev => ({
            ...prev,
            token: {
                ...prev.token,
                authorization: data.authorization,
            },
        }));
    }

    return data;
};

//handles all the requests GET/POST/PUT/DELETE
const requestHandler = async (method, endpoint, payload = null, headers = {}, extras = {}, isImgApi = false) => {
    if (!endpoint) return;

    const { customer, setCustomer, rf, navigate } = extras || {};

    // Prevent execution if customer or setCustomer is missing
    // if (!customer || !setCustomer) {
    //     console.warn("Request blocked: Missing customer or setCustomer");
    //     return;
    // }

    try {
        const api = isImgApi ? ImgAPI : Api;
        const response = await api[method](endpoint, ...(payload ? [payload, headers] : [headers]));
        return await handleAuth(response.data, customer, setCustomer, rf, navigate);
    } catch (err) {
        return {
            success: false,
            err: true,
            msg: "Internal Server error",
        };
    }
};

export const GetRequest = (endpoint, headers, extras) =>
    requestHandler("get", endpoint, null, headers, extras);

export const PostRequest = (endpoint, payload, imgApi, headers, extras) =>
    requestHandler("post", endpoint, payload, headers, extras, imgApi);

export const PutRequest = (endpoint, payload, headers, extras) =>
    requestHandler("put", endpoint, payload, headers, extras);

export const DeleteRequest = (endpoint, headers, extras) =>
    requestHandler("delete", endpoint, null, headers, extras);

//update reference token
export const UpdateRF = async (endpoint) => {
    try {
        const response = await Api.get(`auth/login/updateRF/${endpoint}`);
        return response.data;
    } catch (err) {
        console.error(`updateRF error`, err);
        return err;
    }
};

